<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="value" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover">
            <template v-slot:field="{ item }">
                <search-select-multiple v-model="item.sampleSetIds" label="Sample Sets" item-text="label" item-value="id" :url="'/api/SampleSets/Autocomplete'" :readonly="readonly" claim="SampleSets" />
                <v-btn @click="goToSampleSetTests">View Sample Sets</v-btn>
            </template>
        </form-base>
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import sampleStorageEnum from '../enums/sampleStorage'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase'),
            searchSelectMultiple: () => import("@/components/SearchSelectMultiple")
        },

        data() {
            return {
                sampleSetForm: () => import('../forms/SampleSetForm'),
                floralVarietyForm: () => import('../forms/FloralVarietyForm'),
                harvestingForm: () => import('../forms/HarvestingForm'),
                memberForm: () => import('../forms/MemberForm'),
                fields: [
                    { type: 'autocomplete', text: 'Member', value: 'memberId', rules: [], form: () => import('./MemberForm'), apiMethod: 'Members', claim: 'Members' },
                    { type: 'autocomplete', text: 'Harvesting', value: 'harvestingId', rules: [], form: () => import('./HarvestingForm'), apiMethod: 'Harvestings', claim: 'Harvestings' },
                    { type: 'custom' },
                    { type: 'autocomplete', text: 'Floral Variety', value: 'floralVarietyId', rules: [v => !!v || 'Floral Variety is required'], isRequired: true, form: () => import('./FloralVarietyForm'), apiMethod: 'FloralVarieties', claim: 'FloralVarieties' },
                    { type: 'coordinates', text: 'Coordinates', value: 'coordinates', rules: [v => !!v || 'Coordinates is required'], isRequired: true },
                    { type: 'number', text: 'Temperature', value: 'temperature', rules: [] },
                    { type: 'enum', text: 'Sample Storage', value: 'sampleStorage', rules: [], items: enumService.enumAsSelectList(sampleStorageEnum) },
                    { type: 'checkbox', text: 'Is Filtered', value: 'isFiltered', rules: [v => (v !== null && v !== '') || 'Is Filtered is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is For Testing', value: 'isForTesting', rules: [v => (v !== null && v !== '') || 'Is For Testing is required'], isRequired: true },
                    { type: 'checkbox', text: 'Is Member Sample', value: 'isMemberSample', rules: [v => (v !== null && v !== '') || 'Is Member Sample is required'], isRequired: true },
                    { type: 'datetime', text: 'Created On', value: 'createdOn', rules: [v => !!v || 'Created On is required'], isRequired: true },
                ],
                apiMethod: 'Samples',
                formTitle: 'Sample',
            }
        },

        methods: {
            goToSampleSetTests() {
                let routeData = this.$router.resolve({ name: 'sampleSetManagement' });
                window.open(routeData.href, '_blank');
            }
        }
    };
</script>
